import Vue from 'vue'
import { formatPrice } from "@/helpers";

Vue.filter('price', function (price) {
  return formatPrice(price)
})
